export default class ChannelService {
  constructor() {
    this.loadScript();
  }

  loadScript() {
    const w = window;
    if (w.ChannelIO) {
      return (window.console.error || window.console.log || function(){console.log('')})('ChannelIO script included twice.');
    }
    const ch = function(...args) {
      ch.c(args);
    };
    ch.q = [];
    ch.c = function(args) {
      ch.q.push(args);
    };
    w.ChannelIO = ch;
    function l() {
      if (w.ChannelIOInitialized) {
        return;
      }
      w.ChannelIOInitialized = true;
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
      s.charset = 'UTF-8';
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
    }
    if (document.readyState === 'complete') {
      l();
    } else if (window.attachEvent) {
      window.attachEvent('onload', l);
    } else {
      window.addEventListener('DOMContentLoaded', l, false);
      window.addEventListener('load', l, false);
    }
  }

  boot(settings) {
    window.ChannelIO('boot', settings);
  }

  shutdown() {
    window.ChannelIO('shutdown');
  }

  logout() {
    window.ChannelIO('updateUser', {
      // languwindowage: 'ko',
      memberId: '',
      profile: {
        name: '',
        mobileNumber: '',
        email: '',
        avatarUrl: '',
      },
    }, function onUpdateUser(error, user) {
      if (error) {
        console.error(error)
      } else {
        console.log('updateUser success', user)
      }
    })
  }

  updateMember(member) {
    window.ChannelIO('updateUser', {
      // languwindowage: 'ko',
      memberId: member.memCd,
      profile: {
        name: member.memNm,
        mobileNumber: member.memPh,
        email: member.memEmail,
        avatarUrl: member.memProfileFileUrl,
      },
    }, function onUpdateUser(error, user) {
      if (error) {
        console.error(error)
      } else {
        console.log('updateUser success', user)
      }
    })
  }
}